import { sitePathConfig } from '@constants/sitePathConfig';

// Port các hàm phân quyền của ra-log-monitor-cms (containers/ListBasePage.js +
// compoments/common/elements/ElementWithPermission.js) sang HÀM THUẦN.
//
// ⚠️ KHÁC license-cms: bản này KHÔNG có `checkRenderActionColumn` (cột Hành động luôn dựng),
//    và `renderButton` duyệt ĐÚNG bằng `id` chứ không phải `index`. Đừng bê helper của license sang.

export const getPagePermissions = (pathname) => {
    const key = Object.keys(sitePathConfig).find((k) => sitePathConfig[k].path === pathname);
    return key ? sitePathConfig[key].permissions : undefined;
};

/** Cổng VÀO TRANG — nguồn ListBasePage.checkPermission, dựa trên permissions[0]. */
export const checkPagePermission = (pathname, userPermissions = []) => {
    return !!Object.keys(sitePathConfig).find((key) => {
        const entry = sitePathConfig[key];
        if (entry.path === pathname || pathname.startsWith(entry.path + '/')) {
            if (entry.permissions && userPermissions.indexOf(entry.permissions[0]) < 0) return false;
            return true;
        }
        return false;
    });
};

/**
 * Nguồn ElementWithPermission: `permissions.some(p => userPermissions.indexOf(p) < 0) ? null : children`
 * ⇒ mảng RỖNG thì HIỆN; có phần tử `undefined` hoặc chuỗi giả ('not_have_update') thì ẨN.
 */
export const hasAllPermissions = (requiredPermissions = [], userPermissions = []) =>
    !requiredPermissions.some((permission) => userPermissions.indexOf(permission) < 0);

/** Nút Sửa: [1] getById + [3] update. Nguồn renderEditButton. */
export const getEditPermissions = (pathname) => {
    const p = getPagePermissions(pathname);
    return [p?.[1], p?.[3]];
};

/** Nút Tạo mới: [2] create. Nguồn renderCreateNewButton. */
export const getCreatePermissions = (pathname) => {
    const p = getPagePermissions(pathname);
    return [p?.[2]];
};

/** Nút Xoá: [4] delete. Nguồn renderDeleteButton. */
export const getDeletePermissions = (pathname) => {
    const permissions = [];
    Object.keys(sitePathConfig).forEach((key) => {
        if (sitePathConfig[key].path === pathname) {
            permissions.push(sitePathConfig[key].permissions[4]);
        }
    });
    return permissions;
};

/** Nguồn renderButton(children, permissions): duyệt theo `id` — ĐÚNG (khác license). */
export const getButtonPermissions = (pathname, permissionIndexes = []) => {
    const requiredPermissions = [];
    Object.keys(sitePathConfig).forEach((key) => {
        if (sitePathConfig[key].path === pathname) {
            permissionIndexes.forEach((id) => {
                requiredPermissions.push(sitePathConfig[key].permissions[id]);
            });
        }
    });
    return requiredPermissions;
};

/**
 * Điều hướng sau đăng nhập — nguồn LoginPage.redirectToAuthPage: duyệt `sitePathConfig` theo thứ tự
 * khai báo, lấy trang đầu tiên có `permissions` mà người dùng có `permissions[0]`; không khớp -> /profile.
 */
export const getRedirectPathAfterLogin = (userPermissions = []) => {
    const key = Object.keys(sitePathConfig).find(
        (k) => sitePathConfig[k].permissions && userPermissions.indexOf(sitePathConfig[k].permissions[0]) > -1,
    );
    return key ? sitePathConfig[key].path : sitePathConfig.profile.path;
};
